import { Ripple } from "@/shared/ui/Ripple";

import { trans } from "@/app/localization/Trans";

export class AddToHomeScreenPopup {
    public static show(confirmHandler?: { () }, uniqueId?: string) {
        const parent = $(".app");
        if (uniqueId !== undefined) {
            if (parent.find(".popup." + uniqueId).length !== 0) return;
        }

        //dim background
        let dim = parent.find("> .dim.popupdim");
        if (dim.length === 0) {
            dim = $('<div class="dim popupdim" />').appendTo(parent);
        } else {
            dim.stop(true, false);
        }

        dim[0].offsetHeight;

        dim.addClass("shown");

        const msg = $('<div class="popup' + (uniqueId === undefined ? "" : " " + uniqueId) + '"/>').appendTo(parent);
        const header = $('<div class="head"/>').appendTo(msg);

        $("<div/> <div/>").appendTo(header);

        $('<div class="title">' + trans.addToHomeScreen.title + "</div>").appendTo(msg);
        $('<div class="text">' + trans.addToHomeScreen.step1 + "</div>").appendTo(msg);
        $('<div class="text">' + trans.addToHomeScreen.step2 + "</div>").appendTo(msg);
        $('<div class="text">' + trans.addToHomeScreen.step3 + "</div>").appendTo(msg);

        const buttonsContainer = $('<div class="btns" />').appendTo(msg);
        const confirmButton = $('<button class="btn confirm">' + trans.general.ok + "</button>").appendTo(
            buttonsContainer
        );

        Ripple.bind(
            confirmButton.click((e) => {
                e.preventDefault();
                AddToHomeScreenPopup.close($(e.currentTarget).parent().parent());
            })
        );

        msg[0].offsetHeight;
        msg.css("margin-top", (msg.height() + 60) / -2);
        msg.addClass("addtohomescreen");
        msg.addClass("shown");
    }

    private static close($popup: JQuery) {
        $popup.addClass("closing")[0].offsetHeight;
        const totalPopups = $(".app > .popup").length;

        $popup
            .removeClass("shown")
            .delay(600)
            .queue((e) => {
                $popup.remove();
                e();
            });

        //check if dim needs to be removed
        if (totalPopups <= 1) {
            const dim = $(".app > .dim.popupdim")
                .delay(250)
                .queue((c) => {
                    dim.removeClass("shown")
                        .delay(350)
                        .queue((a) => {
                            dim.remove();
                            a();
                        });

                    c();
                });
        }
    }
}
